import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsOptional } from 'class-validator'
import { IDateRangeFilter } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/inner/IDateRangeFilter'
import { IsRequired } from 'submodules/nerit-framework-utils/validators'

export class NonConformityChartFiltersFormModel extends FormModel {

    @IsRequired()
    locationCodes?: number[]

    @IsRequired()
    fieldRegulationCode?: number

    @IsOptional()
    samplingCode?: number

    @IsOptional()
    dateRange?: IDateRangeFilter

    constructor(initialData?: Partial<NonConformityChartFiltersFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
